// 控制传感器类型展示的对应tabs

// 上报规则
import { hasPermission } from '@/utils/permission'

const rule = {
  type: 'rule',
  label: 'public.escalation_rules'
}

// 网络参数
const net = {
  type: 'net',
  label: 'public.net_param'
}

// 配置日志
const config = {
  type: 'config',
  label: 'device.config_log'
}

// 声光报警
const soundLight = {
  type: 'SoundLightAlarm',
  label: 'public.sound_light_alarm'
}

// gps定位
const gps = {
  type: 'GPSLocate',
  label: 'integration.gps_p'
}

/**
 * 根据规则获取tabs
 * @param type 传感器类型
 */
export const getTabs = type => {
  let tabs = []

  switch (type) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
      // 1~6是一代温度计  包括Lora zeta zigbee
      tabs = [rule, net, config]
      break
    case 7:
    case 8:
      // 7~8是普通二代温度计
      tabs = [rule, config]
      break
    case 9:
    case 10:
      // 9~10是4G温度计
      tabs = [rule, soundLight, config]
      break
    case 11:
    case 12:
      // 11~12是4G温度计带GPS
      tabs = [rule, soundLight, gps, config]
      break
  }
  /**
   * 权限校验
   */
  return tabs.filter(tab => {
    switch (tab.type) {
      case 'rule':
        return hasPermission(['viewSensorAppConfig'])
      case 'net':
        return hasPermission(['viewSensorNetConfig'])
      case 'config':
        return hasPermission(['viewSensorConfigLog'])
      case 'SoundLightAlarm':
        return hasPermission(['viewSensorAlarmConfig'])
      case 'GPSLocate':
        return hasPermission(['viewSensorGpsConfig'])
      default:
        return true
    }
  })
}
